export var providerRedirectPath = '/dashboard';
export var userRedirectPath = '/'; // Default path to redirect after login

export var defaultRedirectPath = providerRedirectPath; // TODO create a comprehensive list on backend

export var forbiddenUsernames = ['about', 'api', 'account', 'booking', 'robots.txt', 'contact', 'env', 'forgot-password', 'password', 'dashboard', 'login', 'logout', 'posts', 'post', 'pricing', 'prospect', 'provider-service', 'reserve', 'settings', 'schedule-embed', 'signup', 'update-password'];
export var calendarMonths = ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'];
export var timeUnits = {
  seconds: 'seconds',
  minutes: 'minutes',
  hours: 'hours',
  days: 'days',
  months: 'months'
};
export var currencySymbols = {
  cad: '$',
  usd: '$',
  eur: '€',
  gbp: '£'
};
export var currencyOptions = [{
  label: 'Select Currency',
  value: ''
}, {
  label: 'USD',
  value: 'usd'
}, {
  label: 'GBP',
  value: 'gbp'
}, {
  label: 'EUR',
  value: 'eur'
}, {
  label: 'CAD',
  value: 'cad'
}];
export var betaProviderBaseUrl = '/beta-provider-signup';
export var betaProviderProfileUrl = "".concat(betaProviderBaseUrl, "/profile");
export var servicePageTabs = {
  booking: 'booking',
  subscriptionPlans: 'subscription-plans',
  posts: 'posts'
};
export var CookieName;

(function (CookieName) {
  CookieName["ACCESS_TOKEN"] = "accessToken";
  CookieName["CONFIRM_EMAIL"] = "confirm-email";
  CookieName["REFRESH_TOKEN"] = "refreshToken";
  CookieName["REFERRAL_PROGRAM_SIGNUP"] = "referral-program-signup";
  CookieName["REFERRAL_PROGRAM_PROVIDER"] = "referral-program-provider";
  CookieName["SERVICE_PASSWORDS"] = "service-passwords";
})(CookieName || (CookieName = {}));

export var OAuthServiceName;

(function (OAuthServiceName) {
  OAuthServiceName["GOOGLE"] = "google";
})(OAuthServiceName || (OAuthServiceName = {}));

export var authReducerMessages = {
  UPDATE_USER_EMAIL_OPTIONS_SUCCESS: 'Successfully unsubscribed from weekly emails'
};
export var staticSessionResources = [{
  id: '0',
  title: 'How to schedule a session',
  url: 'https://www.notion.so/How-to-schedule-a-session-b938a5f856f94d03939168e4979fb453',
  order: 1
}, {
  id: '1',
  title: 'How to promote your session',
  url: 'https://www.notion.so/How-to-promote-your-session-989d8ef73fe64d2b85f229845bc93a47',
  order: 2
}];
export var staticReferralProgramResources = [{
  title: 'Generate word-of-mouth with a killer referral program',
  url: 'https://www.notion.so/Generate-word-of-mouth-with-a-killer-referral-program-d3dbb2a0bf5047888b04c609c13acae2',
  order: 1,
  id: '0'
}];
export var bugsnagIgnoredErrorCodes = [404];
export var googleCalendarUrl = "https://calendar.google.com/calendar/u/0/r/week/";
export var superUserEmailHashes = ['$2a$10$7WaL95LE2uDXqdhfvqtR8OjijXLUnI9UZDRR0bcmnnkkHgai9nxpG', // evelyn
'$2a$10$RO2ltusInLiVx1PET1Qo8etw3r426795k9I6BnJhY67Y4P1ZDDa6S', // bora
'$2a$10$PdtanQh2znq01BJA5MUMsu0xqmGgudje/HQVw7i6lw11nx8kYi182', // casen
'$2a$10$zGscEgectpIDZm6/cN535.2pHvvCjAzHI6.ocFs26f1Hehs9R3wxu', // tim
'$2a$10$2O3Pcl9Ds0B26/7exmzMbeDBCuABCb.alxLBLCwy76GbpcMtR2fay', // tom
'$2a$10$skbWfK9fjHJ/1HR4aCxx7uXpsAL4K/Tn56Ipi79/VhYUm3cCcgEvO' // beth
];